import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button, IconButton } from '@openedx/paragon';
import { Close } from '@openedx/paragon/icons';

import messages from '@src/courseware/course/sidebar/sidebars/course-outline/messages';
import { BackArrow } from './generic/icons';

const OutlineHeader = ({
  isDisplaySequenceLevel,
  backButtonTitle,
  shouldDisplayFullScreen,
  handleBackToSectionLevel,
  handleToggleCollapse,
}) => {
  const intl = useIntl();
  return (
    <div className="sticky outline-heading-wrapper m-0">
      {isDisplaySequenceLevel && backButtonTitle ? (
        <Button
          variant="link"
          iconBefore={BackArrow}
          className="p-0 pl-2 text-primary-500 text-decoration-none"
          onClick={handleBackToSectionLevel}
        >
          <span className="heading-text">
            {backButtonTitle}
          </span>
        </Button>
      ) : (
        <div className="heading-text pl-1.5">
          {intl.formatMessage(messages.courseOutlineTitle)}
        </div>
      )}
      {shouldDisplayFullScreen && (
        <IconButton
          alt={intl.formatMessage(messages.toggleCourseOutlineTrigger)}
          iconAs={Close}
          onClick={handleToggleCollapse}
          className="icon-hover"
        />
      )}
    </div>
  );
};

OutlineHeader.propTypes = {
  isDisplaySequenceLevel: PropTypes.bool.isRequired,
  backButtonTitle: PropTypes.string.isRequired,
  shouldDisplayFullScreen: PropTypes.bool.isRequired,
  handleBackToSectionLevel: PropTypes.func.isRequired,
  handleToggleCollapse: PropTypes.func.isRequired,
};

export default OutlineHeader;
